import React, { Component } from 'react';
import { OpenFileLink } from '../../../common/components/data-display';
import { t } from '../../../app/i18n';
import { selectToken } from '../../../features/auth/ducks';
import DatePicker from 'antd/lib/date-picker';
import { connect } from 'react-redux';
import moment from 'moment';


const { RangePicker, MonthPicker } = DatePicker;
const mapStateToProps = state => ({
  token: selectToken(state)
});

@connect(mapStateToProps)
export default class AccountExportsContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      taxDates: {
        from: moment.utc().subtract(1, 'year').startOf('year').toISOString(),
        to: moment.utc().subtract(1, 'year').endOf('year').toISOString()
      },
      investmentsDates: {
        from: moment.utc().subtract(1, 'year').startOf('day').toISOString(),
        to: moment.utc().endOf('day').toISOString()
      }
    }
  }

  onFilterDateRangeChange = key => ([dateFrom, dateTo]) => {
    this.setState({
      [key]: {
        from: dateFrom ? dateFrom.startOf('day').toISOString() : "",
        to: dateTo ? dateTo.endOf('day').toISOString() : ""
      }
    });
  };

  onTaxMonthChange = key => month => {
    const taxDate = month
      ? (key === 'from'
          ? month.clone().startOf('month')
          : month.clone().endOf('month')
        ).toISOString()
      : '';

    this.setState({
      taxDates: {
        ...this.state.taxDates,
        [key]: taxDate,
      },
    });
  };

  disabledTaxMonth = current => {
    const minMonth = moment
      .utc()
      .subtract(4, 'years')
      .startOf('year');
    const maxMonth = moment.utc().endOf('month');

    return (
      current &&
      (current
        .clone()
        .endOf('month')
        .isBefore(minMonth) ||
        current
          .clone()
          .startOf('month')
          .isAfter(maxMonth))
    );
  };

  render() {
    const {
      token,
    } = this.props;

    return (
      <div>
        {token && (
          <div>
            <div>
              <div style={{ marginBottom: 15 }}>
                <h2>Export pre daňové účely</h2>
              </div>

              <MonthPicker
                onChange={this.onTaxMonthChange('from')}
                format="MM.YYYY"
                disabledDate={this.disabledTaxMonth}
                style={Object.assign({ marginRight: 15 }, { float: 'left' })}
                defaultValue={moment.utc(this.state.taxDates.from)}
              />
              <MonthPicker
                onChange={this.onTaxMonthChange('to')}
                format="MM.YYYY"
                disabledDate={this.disabledTaxMonth}
                style={Object.assign({ marginRight: 15 }, { float: 'left' })}
                defaultValue={moment.utc(this.state.taxDates.to)}
              />

              <OpenFileLink
                isButton
                href={`${process.env.REACT_APP_API_URL}/loan/reportPaymentInvestor?token=${token}&accountId=${this.props.account.id}&dateFrom=${this.state.taxDates.from}&dateTo=${this.state.taxDates.to}`}
                style={{ marginLeft: 15 }}
                classNames="primary"
              >
                Export
              </OpenFileLink>
            </div>
            <br></br>
            <div>
              <div style={{ marginBottom:15}}><h2>Export investícií</h2></div>

              <RangePicker
                onChange={this.onFilterDateRangeChange('investmentsDates')}
                format="DD.MM.YYYY"
                style={Object.assign({ marginRight: 15 }, {float:'left'})}
                defaultValue={[moment.utc(this.state.investmentsDates.from), moment.utc(this.state.investmentsDates.to)]}
              />

              <OpenFileLink
                isButton
                href={`${process.env.REACT_APP_API_URL}/loan/reportInvestmentsStatus?token=${token}&accountId=${this.props.account.id}&dateFrom=${this.state.investmentsDates.from}&dateTo=${this.state.investmentsDates.to}`}
                style={{ marginLeft: 15 }}
                classNames="primary"
              >
                Export
              </OpenFileLink>
            </div>
            <br></br>
            <div>
              <div style={{ marginBottom: 15 }}><h2>Export očakávaných splátok</h2></div>

              <OpenFileLink
                isButton
                href={`${process.env.REACT_APP_API_URL}/loan/reportExpectedInvestorInstallments?token=${token}&accountId=${this.props.account.id}`}
                style={{ marginLeft: 15 }}
                classNames="primary"
              >
                Export
              </OpenFileLink>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountExportsContainer.js